export default "__VITE_ASSET__ChOWtubU__"